// --- Inventory Data and Logic ---
// (Combine any inventory-related data and helpers here)

import { allSeeds } from '../../data/seedData';

// Debounce function to limit the rate of function execution
export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

// Load saved inventory from localStorage
export function loadInventory() {
  const savedInventory = localStorage.getItem('chainersInventory');
  if (savedInventory) {
    return JSON.parse(savedInventory);
  }
  return {
    beds: {},
    seeds: {},
    animals: {}
  };
}

// Save inventory to localStorage
export function saveInventory(inventory) {
  localStorage.setItem('chainersInventory', JSON.stringify(inventory));
}

// Sort and flatten all seeds for display
export function getSortedSeeds() {
  const foodSeeds = ['Corn', 'Peas', 'Cabbage', 'Radish'];
  const allSeedItems = [];
  const foodSeedItems = [];
  const seasons = Object.values(allSeeds);
  for (let i = 0; i < seasons.length; i++) {
    const season = seasons[i];
    if (Array.isArray(season)) {
      for (let j = 0; j < season.length; j++) {
        const seed = season[j];
        const seedData = {
          id: seed.id,
          name: seed.name,
          rarities: [...seed.rarity].sort((a, b) => {
            const order = { 'Common': 0, 'Uncommon': 1, 'Rare': 2, 'Epic': 3, 'Legendary': 4 };
            return order[a.type] - order[b.type];
          }),
          image: `/images/seeds/${seed.id || seed.name.toLowerCase().replace(/\s+/g, '_')}/common/preview.png`,
          isFoodSeed: foodSeeds.includes(seed.name)
        };
        if (seedData.isFoodSeed) {
          foodSeedItems.push(seedData);
        } else {
          allSeedItems.push(seedData);
        }
      }
    }
  }
  foodSeedItems.sort((a, b) => a.name.localeCompare(b.name));
  allSeedItems.sort((a, b) => a.name.localeCompare(b.name));
  return [...foodSeedItems, ...allSeedItems];
}

// Utility to split food seeds and other seeds
export function splitSeeds(sortedSeeds) {
  const foodSeedIds = ['corn', 'peas', 'radish', 'cabbage'];
  const foodSeeds = [];
  const otherSeeds = [];
  sortedSeeds.forEach(seed => {
    if (foodSeedIds.includes(seed.id)) {
      foodSeeds.push(seed);
    } else {
      otherSeeds.push(seed);
    }
  });
  const foodSeedOrder = { 'corn': 0, 'peas': 1, 'radish': 2, 'cabbage': 3 };
  foodSeeds.sort((a, b) => foodSeedOrder[a.id] - foodSeedOrder[b.id]);
  return { foodSeeds, otherSeeds };
}

// Add more helpers as needed for beds and animals 